export default {
  name: 'dark',
  colors: {
    background: '#0F102C',
    primary: '#1C1D44',
    secondary: '#141C2F',
    button: '#0DA3B8',
    font: '#FFFFFF',
    title: '#FFFFFF',
  },
};
